import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';

export default function wcgwTaskScotsreducer(state = initialstate.wcgwTasksScots, action) {
	switch (action.type) {
		case types.GET_SCOTS_FOR_ASSERTIONIDS: {
			const foundScots = state?.byId && state?.byId[action.meta.accountId];

			if (foundScots && action?.response?.data && action?.response?.data.length > 0) {
				foundScots?.forEach((element) => {
					action.response?.data?.forEach((scot) => {
						if (element.id === scot.id) {
							scot.isExpanded = element.isExpanded;
						}
					});
				});
			}

			return normalize(action?.response?.data, state?.allIds?.length > 0 ? state : undefined, action.meta.accountId);
		}
		case types.PUT_WCGW_TASK:
			if (action.error) {
				return state;
			}
			const data =
				state &&
				state?.allIds?.length > 0 &&
				state?.allIds?.map((id) => {
					var wcgWs = _.cloneDeep(state?.byId[id])?.map((element) => {
						element.wcgWs.map((wcgw) => {
							if (wcgw.id === action.response.wcgwId) {
								wcgw.assertionTaskCount++;
							}

							return wcgw;
						});

						return {
							...element,
							wcgWs: wcgWs
						};
					});
				});

			return {
				...state,
				data: data
			};
		case types.UPDATE_SCOT_EXPANDED: {
			if (action.data) {
				const result = {...state};

				result.byId[action.data.accountId].forEach((scot) => {
					if (scot.id === action.data.scotId) {
						scot.isExpanded = action.data.isExpanded;
					}
				});

				return result;
			}
			break;
		}
		default:
			return state;
	}
}

const normalize = (field, accumulator, key) => {
	let result;

	// If an accumulator is passed, the result should be at least, that
	if (accumulator) {
		result = {
			byId: {...accumulator.byId},
			allIds: [...accumulator.allIds]
		};
	}

	// If field was correctly passed and result is still undefined, initialize it
	if (!result) {
		result = {
			byId: {},
			allIds: []
		};
	}

	// Run array normalization logic
	if (Array.isArray(field)) {
		if (!result.byId[key]) {
			result.allIds.push(key);
		}
		result.byId[key] = field;
	}

	return result;
};
